export default __webpack_public_path__ + "static/media/paper-plane-svgrepo-com.d6b5ea5c.svg";